import { z } from 'zod'

// ---- Profile ----

export const updateProfileSchema = z.object({
  firstName: z.string().min(1, 'Ce champ est requis'),
  lastName: z.string().min(1, 'Ce champ est requis'),
  birthDate: z.string().nullable().optional(),
  gender: z.enum(['MALE', 'FEMALE']).nullable().optional(),
})

// ---- Phone numbers ----

export const updatePhoneNumbersSchema = z.object({
  phoneNumbers: z
    .array(
      z.object({
        id: z.string().optional(),
        number: z.string().min(1, 'Le numéro est requis'),
        type: z.string().min(1, 'Le type est requis'),
      })
    )
    .min(1, 'Au moins un numéro est requis'),
})

// ---- Emails ----

export const updateEmailsSchema = z.object({
  email: z.string().min(1, 'Ce champ est requis').email('Veuillez saisir une adresse email valide'),
  secondaryEmail: z
    .string()
    .email('Veuillez saisir une adresse email valide')
    .or(z.literal(''))
    .optional(),
  password: z.string().min(1, 'Le mot de passe est requis'),
})

// ---- Password ----

export const updatePasswordSchema = z
  .object({
    confirmNewPassword: z.string().min(1, 'Ce champ est requis'),
    currentPassword: z.string().min(1, 'Ce champ est requis'),
    newPassword: z.string().min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
  })
  .superRefine((data, ctx) => {
    if (data.newPassword !== data.confirmNewPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Les mots de passe ne correspondent pas',
        path: ['confirmNewPassword'],
      })
    }
  })

// ---- Passenger ----

export const passengerSchema = z.object({
  firstName: z.string().min(1, 'Ce champ est requis'),
  lastName: z.string().min(1, 'Ce champ est requis'),
  birthDate: z.string().min(1, 'Ce champ est requis').nullable(),
  gender: z.enum(['MALE', 'FEMALE']),
  nationality: z.object({
    label: z.string(),
    value: z.string().min(1, 'La nationalité est requise'),
  }),
})

// ---- Identity document ----

export const identityDocumentSchema = z.object({
  documentNumber: z.string().min(1, 'Le numéro est requis'),
  expiryDate: z.string().min(1, "La date d'expiration est requise").nullable(),
  issuingCountry: z.object({
    label: z.string(),
    value: z.string().min(1, 'Le pays est requis'),
  }),
  type: z.enum(['CNI', 'PASSPORT']),
})

// ---- Fidelity card ----

export const fidelityCardSchema = z.object({
  cardNumber: z.string().min(1, 'Le numéro est requis'),
  company: z.object({
    label: z.string(),
    value: z.string().min(1, 'La compagnie est requise'),
  }),
})
